import merge from 'lodash/merge';
import defaultTheme from './default-theme';

export class ThemeHelper {
  /**
   * If props contains no theme object or the theme object is empty, returns the base theme
   * Otherwise recursively merges props.theme on top of base theme
   */
  static getTheme(props) {
    if (props.theme && Object.keys(props.theme).length > 0) {
      return merge({}, defaultTheme, props.theme);
    }
    return defaultTheme;
  }

  static getDefaultTheme() {
    return defaultTheme;
  }

  /* Calculate any theme overrides of the default values for this component */
  static getComponentOverrides(theme, component, defaultValues) {
    return merge({}, defaultValues(theme), theme.overrides[component]);
  }
}



// WEBPACK FOOTER //
// ./styles/theme-helper.js